export default __webpack_public_path__ + "static/media/MarginImpactBulkUpdate.908c3a6d.png";